import React, { useState, useEffect } from 'react';
import { selectPaginatedRequestStatus } from '../../reducers/eventsSlice';
import LoadingIndicator from '../common/LoadingIndicator';
import EventsList from '../project/EventsList';
import { PageCenteredLayout } from '../layout/PageCenteredLayout';

// Custom hook to detect if screen is below the lg breakpoint (1024px)
const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024); // 1024px is the lg breakpoint in Tailwind
    };

    // Check on initial render
    checkScreenSize();

    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  return isMobile;
};

export default function EventDeploymentsPage() {
  const isMobile = useIsMobile();

  return (
    <PageCenteredLayout>
      {/* Only show the title when on mobile (sidebar is hidden) */}
      {isMobile && <h1 className="mb-6 text-3xl text-dataops-rich-black">Events</h1>}
      <LoadingIndicator selectRequestStatus={selectPaginatedRequestStatus} />
      <EventsList />
    </PageCenteredLayout>
  );
}
